import { css } from '@emotion/react';
import axios from 'axios';
import { CountryEnum, DistanceEnum, FilterEntityInterface, GenderEnum, ProvidersEnum, SearchTypeEnum } from './Filter.interface';
import { DisplayInputValue, GeneralInputBundle } from '../ProviderAutocomplete/AutocompleteInput/AutocompleteInput';
import urlWrapper from '../../../../utils/urlWrapper';

// LABELS
export const LABEL_CLEAR = 'CLEAR';
export const LABEL_APPLY = 'APPLY';
export const DistanceLabel = 'Distance';
export const PostalCodeLabel = 'Postal Code Of Current Location';
export const ProvinceLabel = 'Province';
export const GenderLabel = 'Sex';
export const LanguageMultiOptionsGroupName = 'Languages Spoken';
export const CatchmentAreaGroupName = 'Catchment area / Health Region';

// MOCKED DATA
export const InitFilterEntity: FilterEntityInterface = {
  distance: [DistanceEnum.DISTANCE_NONE],
  languages: [],
  provinces: [],
  gender: [GenderEnum.GENDER_ALL],
  country: [CountryEnum.COUNTRY_CANADA],
  catchmentArea: [],
  specialty: [],
  city: [],
  name: [],
  near: [],
};

export const TotalGenders: DisplayInputValue[] = Object.entries(GenderEnum).map(([, value]) => ({
  code: value,
  display: value,
}));

export const TotalDistance: DisplayInputValue[] = Object.entries(DistanceEnum)
  .filter(([, value]) => !!value)
  .map(([, value]) => ({
    code: value,
    display: value,
  }));

export const TotalCountries: DisplayInputValue[] = Object.entries(CountryEnum).map(([, value]) => ({
  code: value,
  display: value,
}));

export const TotalSearchingGroups: DisplayInputValue[] = Object.entries(SearchTypeEnum).map(([, value]) => ({
  code: value,
  display: value,
}));

export const TotalProviderGroups: DisplayInputValue[] = Object.entries(ProvidersEnum).map(([, value]) => ({
  code: value,
  display: value,
}));

export const FilterDelay = 100;

// QUERIES
export const loadValueSet = async (valueSetName: string, token: string) => {
  const { data } = await axios.get<GeneralInputBundle>(urlWrapper(`/v1/fhir/ValueSet/${valueSetName}`), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return data.compose.include.reduce((total, curr) => {
    return total.concat(curr.concept);
  }, [] as DisplayInputValue[]);
};

// STYLESHEETS
export const FilterContainerWrapperStyle = css`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
export const FilterContainerStyle = css`
  display: flex;
  flex-direction: column;
  border: 1px solid #c4c4c4;
  border-radius: 4px 4px 0 0;
  background: #fff;
  position: relative;
  justify-content: space-between;
  flex: 1;
`;

export const FilterChildSharedStyle = css`
  padding: 0.75rem;
  border-bottom: 1px solid #c4c4c4;
`;

export const DistanceTableContainerStyle = css`
  padding: 0.75rem;
  border-bottom: 1px solid #c4c4c4;
`;

export const FilterChildNameSharedStyle = {
  paddingBottom: '0.5rem',
};

export const RadioCellStyle = { display: 'flex', alignItems: 'center', marginRight: '1rem' };
export const RadioComponentStyle = { p: 0 };
export const RadioLabelStyle = { m: 0 };

export const DistanceContainerStyle = css`
  box-shadow: 0 0 2px 0 #000;
  padding: 1rem;
`;

export const MenuItemStyle = {
  paddingLeft: 0,
  paddingRight: 0,
  paddingTop: 0,
  paddingBottom: 0,
  m: 0,
  flex: 1,
};

export const DistanceListStyle = {
  marginTop: '0.5rem',
  display: 'flex',
  flexDirection: 'column',
};

export const TableContainerStyle = {
  p: '1rem',
};

// REGEX
export const DistanceRegEx = /^\d{0,3}$/g;
export const PostalCodeRegEx = /(^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$)|(^\d{5}(-\d{4})?$)/;
